"use client";

import { ReactNode } from "react";
import type { QuoteLayoutConfig } from "@/@sdk/brands/brand-model";
import { iHolidayQuoteX } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { QuotePageMainContent } from "./quote-page-main-content";

export interface QuotePageLayoutProps {
  layoutConfig: QuoteLayoutConfig;
  headerTemplate: "Wide" | "Default";
  greetings: ReactNode;
  quote: iHolidayQuoteX;
  mainContent?: ReactNode;
}

function getLayoutOptions(layoutConfig: QuoteLayoutConfig) {
  return {
    itinerarySummaryVariant:
      layoutConfig === "CONFIG_C" ? ("compact-strip" as const) : ("default" as const),
    pricingMode:
      layoutConfig === "CONFIG_B"
        ? ("sidebar" as const)
        : layoutConfig === "CONFIG_C"
          ? ("grid-asymmetric" as const)
          : ("grid" as const),
  };
}

export function QuotePageLayout({
  layoutConfig,
  headerTemplate,
  greetings,
  quote,
  mainContent,
}: QuotePageLayoutProps) {
  const greetingsShellClassName =
    headerTemplate === "Wide" || layoutConfig === "CONFIG_C"
      ? "mx-auto"
      : "mx-auto max-w-screen-xl space-y-8 px-4 py-8";

  const layoutOptions = getLayoutOptions(layoutConfig);

  return (
    <>
      <main className={greetingsShellClassName}>{greetings}</main>

      {mainContent ?? (
        <QuotePageMainContent quote={quote} {...layoutOptions} />
      )}
    </>
  );
}

export { getLayoutOptions };
